import { MicIcon, SpeakerIcon, VideoIcon, ChevronDownIcon } from "lucide-react";

interface VideoSectionProps {
    videoSrc?: string;
    microphoneLabel?: string;
    speakerLabel?: string;
    cameraLabel?: string;
}

export default function PreviewVideoSection({
    videoSrc = "https://asset.ourteam.ai/commons/ourteam-demo-preview.png",
    microphoneLabel = "Microphone Array",
    speakerLabel = "Default Speaker",
    cameraLabel = "USB2.0 FHD Camera",
}: VideoSectionProps) {
    return (
        <div className="flex-1 px-0 py-2">
            <div className="space-y-4">
                {/* Video Container */}
                <div className="relative bg-gray-900 rounded-lg overflow-hidden aspect-video">
                    {/* Candidate Video */}
                    <img
                        src={videoSrc}
                        alt="Interview preview"
                        className="w-full h-full object-cover"
                    />

                    {/* You label */}
                    <div className="absolute bottom-4 left-4">
                        <span className="bg-black/70 text-white text-xs px-2 py-1 rounded">
                            You
                        </span>
                    </div>
                </div>

                {/* Device Controls - Below Video */}
                <div className="flex items-center justify-center gap-4">
                    {/* Microphone Selector */}
                    <div className="flex items-center gap-1.5 cursor-pointer hover:bg-gray-50 rounded-lg px-2 py-2 transition-colors min-w-0">
                        <MicIcon className="w-4 h-4 text-gray-600 flex-shrink-0" />
                        <span className="text-xs text-gray-700 font-medium truncate max-w-[120px]">
                            {microphoneLabel}
                        </span>
                        <ChevronDownIcon className="w-3 h-3 text-gray-400 flex-shrink-0" />
                    </div>

                    {/* Speaker Selector */}
                    <div className="flex items-center gap-1.5 cursor-pointer hover:bg-gray-50 rounded-lg px-2 py-2 transition-colors min-w-0">
                        <SpeakerIcon className="w-4 h-4 text-gray-600 flex-shrink-0" />
                        <span className="text-xs text-gray-700 font-medium truncate max-w-[120px]">
                            {speakerLabel}
                        </span>
                        <ChevronDownIcon className="w-3 h-3 text-gray-400 flex-shrink-0" />
                    </div>

                    {/* Camera Selector */}
                    <div className="flex items-center gap-1.5 cursor-pointer hover:bg-gray-50 rounded-lg px-2 py-2 transition-colors min-w-0">
                        <VideoIcon className="w-4 h-4 text-gray-600 flex-shrink-0" />
                        <span className="text-xs text-gray-700 font-medium truncate max-w-[120px]">
                            {cameraLabel}
                        </span>
                        <ChevronDownIcon className="w-3 h-3 text-gray-400 flex-shrink-0" />
                    </div>
                </div>
            </div>
        </div>
    );
}
